// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: 'd6dd9ec',
    builtAt: '2026-10-08T13:41:42.091Z',
} as const;
